import "./Survey.scss";

import React from "react";

// import { Link } from 'react-router-dom';
import config from "../../config/config";
import { selectContentDictionary } from "../../reduxToolkit/features/contentSlice";
import { useAppSelector } from "../../reduxToolkit/hooks";
import { redirectToUrl } from "../../services/utilities";

const Survey = (): React.JSX.Element => {
  // START: GitHub Copilot Generated Code
  const contentDictionary = useAppSelector(state => selectContentDictionary(state, 'survey'));
  // contentMiddleware automatically loads content when language changes — no useEffect needed
  // END: GitHub Copilot Generated Code
  const { urlConfig } = config;
  // const withIos = isIosApp();
  // const browserView = !isMobileApp();
  return (
    <>
      <div className='survey-header'> {contentDictionary?.headline} </div>
      <div className='survey-content'>{contentDictionary?.message}</div>
      <div className='w-100'>
        {/* {!browserView ?
          <Link className='btn survey-button' to={urlConfig.surveyRoute} target='_blank'>{contentDictionary?.button}</Link>
          :
          <button className='btn survey-button'
            onClick={() => redirectToUrl(urlConfig.surveyLink, 'new')}
          >
            {contentDictionary?.button}
          </button>
        } */}
        <button className='btn survey-button'
          onClick={() => redirectToUrl(urlConfig.surveyLink, 'new')}
        >
          {contentDictionary?.button}
        </button>
      </div>
    </>
  );
};

export default Survey;
